import React from 'react';
import { TextField } from '@mui/material';

const LabeledTextField = ({ label, value, onChange, error = false, helperText = '', ...props }) => (
    <TextField
        fullWidth
        label={label}
        value={value}
        onChange={onChange}
        error={error}
        helperText={helperText}
        {...props}
    />
);

export default LabeledTextField; 